import { useMemo } from 'react';
import { Loader } from '../../../components/loading/Loader';
import { Panel } from '../../../components/panels/Panel';
import {
  formatVeralliaDashboardDateTime,
  formatVeralliaDashboardSize,
  getVeralliaDashboardDefectCatalogue,
} from '../../../services/dashboard/verallia-dashboard-service';
import { VeralliaDashboardNoData } from './components/VeralliaDashboardBlocks';

export const VeralliaDashboardDefectCatalogue = ({ detections, isInfluxLoading, hasInfluxError }) => {
  const catalogue = useMemo(() => {
    return getVeralliaDashboardDefectCatalogue(detections);
  }, [detections]);

  if (isInfluxLoading) return <Loader/>;

  return (
    <Panel title="CATÁLOGO DE DEFECTOS">
      <div className="mx-auto w-11/12 py-6">
        {hasInfluxError ? (
          <VeralliaDashboardNoData text="No se han podido cargar los datos."/>
        ) : (
          <div className="grid grid-cols-1 gap-4 xl:grid-cols-2 2xl:grid-cols-3">
            {catalogue.map((defect) => (
              <Panel key={defect.id} noHeader rounded category="secondary" overflowAuto={false}>
                <div className="flex h-full flex-col">
                  <div className="border-b border-perception-black-800 pb-4">
                    <div className="text-lg font-semibold text-perception-gray-300">{defect.name}</div>
                  </div>

                  <div className="flex flex-1 flex-col gap-4 pt-4">
                    <div className="grid grid-cols-2 gap-x-6 gap-y-2 text-sm">
                      <div className="text-perception-gray-600">Tamaño medio</div>
                      <div className="text-right text-perception-gray-300">{formatVeralliaDashboardSize(defect.averageSize)}</div>

                      <div className="text-perception-gray-600">Tamaño máximo</div>
                      <div className="text-right text-perception-gray-300">{formatVeralliaDashboardSize(defect.maxSize)}</div>

                      <div className="text-perception-gray-600">Líneas afectadas</div>
                      <div className="text-right text-perception-gray-300">{defect.linesAffected}</div>

                      <div className="text-perception-gray-600">Última detección</div>
                      <div className="text-right text-perception-gray-300">
                        {defect.lastSeen ? formatVeralliaDashboardDateTime(defect.lastSeen, false) : '—'}
                      </div>
                    </div>

                    <div className="mt-auto border-t border-perception-black-800 pt-4">
                      <div className="mb-2 flex justify-between text-sm">
                        <span className="text-perception-gray-600">Cantidad detectada</span>

                        <div className="flex gap-2">
                          <span className="text-perception-gray-300">{defect.count}</span>
                          <span className="text-perception-gray-600">{defect.share.toFixed(1)}%</span>
                        </div>
                      </div>

                      <div className="h-2 overflow-hidden rounded-full bg-perception-black-800">
                        <div className="h-full bg-perception-blue" style={{ width: `${defect.share}%` }}/>
                      </div>
                    </div>
                  </div>
                </div>
              </Panel>
            ))}
          </div>
        )}
      </div>
    </Panel>
  );
};